import { render, staticRenderFns } from "./BookingRoomFormDialog.vue?vue&type=template&id=b1952a30"
import script from "./BookingRoomFormDialog.vue?vue&type=script&lang=js"
export * from "./BookingRoomFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports